/**
 * @fileoverview GET handler for the "/engagement/predictions/get_custom_event_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionsGetCustomEventNames } from "./constants";
import type { EngagementPredictionsGetCustomEventNamesResult } from "./types";

export const getEngagementPredictionsGetCustomEventNames = reactQueryFetcherAdapter(
  engagementPredictionsGetCustomEventNames,
  (
    signal: AbortSignal,
    appGroupid: string,
    searchTerm: string,
    limit: number
  ): Promise<EngagementPredictionsGetCustomEventNamesResult> => {
    return fetch(
      "/engagement/predictions/get_custom_event_names",
      "GET",
      { app_group_id: appGroupid, search_term: searchTerm, limit: limit },
      { signal }
    );
  }
);
